import React from 'react';
import noImage from '../../assets/icons/no-image.jpg';
import { formatDistance } from '../../utils/formatters';
import { FormattedOpeningHours } from './FormattedOpeningHours';
import routeIcon from '../../assets/icons/route.svg';
import disabledIcon from '../../assets/icons/disabled.svg';
import closeIcon from '../../assets/icons/poi-close.svg';
import websiteIcon from '../../assets/icons/website.svg';
import phoneIcon from '../../assets/icons/phone.svg';

const getWebsiteUrl = (url) => {
  if (!url) return '';
  return url.startsWith('http://') || url.startsWith('https://')
    ? url
    : `https://${url}`;
};

const POIDetails = ({ poi, onClose, isDesktop = false }) => {
  return (
    <div className="poi-details-sheet">
      <div className="poi-details-header" style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
          <img
            className="place-img"
            src={poi.image_url && poi.image_url.trim() !== '' ? poi.image_url : noImage}
            alt={poi.poi_name}
          />
        <button
          className="poi-details-close-btn"
          aria-label="Close POI details"
          onClick={onClose}
        >
          <img src={closeIcon} alt="Close" className="poi-close-icon" />
        </button>
      </div>
      <div className="poi-details-container">
        <div className="place-title" style={{marginBottom: 10}}>{poi.poi_name}</div>
        <div className="place-tags">
          {poi.distance != null && (
            <span className="tag distance-tag">
              {formatDistance(poi.distance)}
            </span>
          )}
          {poi.poi_category && <span className="tag">{poi.poi_category}</span>}
          {poi.entry_fee && <span className="tag">{poi.entry_fee}</span>}
          {poi.disable_access_y_n === "Yes" && (
            <span className="tag">
              <img src={disabledIcon} className="disabled-img" alt="disabled" />
            </span>
          )}
          {poi.opening_hours_days && (
            <FormattedOpeningHours hours={poi.opening_hours_days} />
          )}
          {poi.website && (
            <div className="place-contact-row">
              <img src={websiteIcon} alt="Website" className="place-contact-icon" />
              <a className="place-contact-value" href={getWebsiteUrl(poi.website)} target="_blank" rel="noopener noreferrer">{poi.website}</a>
            </div>
          )}
          {poi.phone && (
            <div className="place-contact-row">
              <img src={phoneIcon} alt="Phone" className="place-contact-icon" />
              <a className="place-contact-value" href={`tel:${poi.phone}`}>{poi.phone}</a>
            </div>
          )}
        </div>
        <a 
          href={poi.google_maps_direction?.replaceAll(' ','')} 
          target="_blank" 
          className="direction-btn" 
          onClick={(e) => e.stopPropagation()}
        >
          <img src={routeIcon} alt="Directions" className="direction-icon" />
          Direction
        </a>
        
        <div className="place-desc expanded">{poi.poi_description}</div>
        {poi.additional_information && (
          <div className="place-desc place-additional-info">{poi.additional_information}</div>
        )}
      </div>
    </div>
  );
};

export default POIDetails; 